module.exports = __webpack_public_path__ + "img/xk3.e155e943.png";